<div class="form-item-view-vertical">
  <input id="enable-app-checkbox" class="form-control form-checkbox  Auto_Create_Hsdp_User"
         type="checkbox"
         [checked]="enabled"
         [ngClass]="{'disabled': !isEditMode}"
         [disabled]="!isEditMode"
         (change)="toggle()"/>
  <span></span>

  <section *ngIf="isEditableResourceAvailable">
    <label> Resource identifier configuration</label>
    <gen-dynamic-form-table
            [itemTitle]="'Resource identifier configuration'"
            [data]="resourcesData"
            [formId]="resourceSelectionForm"
            [formVertical]="false"
            [tableVertical]="true"
            [viewAsTable]="true"
            [itemRequiredMessage]="'Required information missing'"
            [editMode]="false"
            [popupMode]="true"
            [showAddButton]="false"
            [showDeleteButton]="false"
            [prioritizeAvailable]="false"
            [schema]=null
            [listenToDataChange]="true"
            [updatedFieldsContextRef]=null
            (itemUpdateEmitter)="updateResourcesData($event)"
            [itemNgClassRef]=null
            [removeItemOnDeleteRef]="false"
            [isItemDisabledRef]=null
            [isItemEditModeRef]=null
            [itemUpdateOnBlurRef]="false"
            [submitted]="false"
            [canDeleteItemRef]="false"
            [disabled]="false"
    ></gen-dynamic-form-table>
    <span></span>
  </section>
  <section *ngIf="enabled">
    <span></span>
    <h4> Permissionschema and Role configuration</h4>
    <gen-dynamic-form
            class="brand-dynamic-form"
            [notifyDefaultValueInit]="true"
            [formData]="itemsFormData"
            [formName]="'ADMIN-APPCONFIGURATION-ITEMS'"
            [formVertical]="true"
            [updateOnBlur]="true"
            [submitted]="null"
            [editMode]="false"
            (formChange)="updateItemsFormData($event)"
            [disabled]="itemsFormDisable">
    </gen-dynamic-form>
    <span></span>
  </section>
  <ng-container *ngIf="formData$ | async as formData">
    <section *ngIf="enabled" style="margin-bottom: 3rem;">
      <hr/>
      <h4>Additional configuration</h4>
      <ng-container *ngIf="appSpecProp$ | async as appSpecificProperties">
        <div *ngFor="let descr of appSpecificProperties">
          <ng-container *ngIf="descr && !!descr.formId">
            <gen-dynamic-form
                    class="app-spec-prop-dynamic-form"
                    [notifyDefaultValueInit]="true"
                    [formData]="descr"
                    [formName]="descr.formId"
                    [formVertical]="false"
                    [updateOnBlur]="true"
                    [submitted]="null"
                    [editMode]="isEditMode"
                    (formChange)="onUpdatedAppSpecificProperty($event)"
                    (validateChange)="updateValidate($event, 0)"
                    [disabled]="!isEditMode">
            </gen-dynamic-form>
          </ng-container>
        </div>
      </ng-container>
      <gen-dynamic-form
              class="brand-dynamic-form"
              [notifyDefaultValueInit]="true"
              [formData]="formData"
              [formName]="basicDataForm"
              [formVertical]="true"
              [updateOnBlur]="true"
              [submitted]="null"
              [editMode]="isEditMode"
              (formChange)="onUpdateData($event)"
              (validateChange)="updateValidate($event,1)"
              [disabled]="!isEditMode">
      </gen-dynamic-form>
      <div class="preview-container">
        <label>Brand Preview</label>
        <gen-brand-preview [chosenBrand]="brandData" [inForm]="true"></gen-brand-preview>
      </div>
    </section>
  </ng-container>
</div>

<section class="actions-container"
         *ngIf="isEditMode && controls">
  <gen-button
          *ngFor="let control of controls"
          [text]="control.name"
          [type]="control.btnType? control.btnType : 'primary'"
          [iconClass]="control.iconClass"
          [disabled]="control.type === 'submit' && (!(brandValid && knowledgeBaseValid))"
          (click)="buttonClick(control.type)">
  </gen-button>
</section>
<section class="actions-container-edit"
         *ngIf="enableEditButton && !isEditMode">
  <gen-button
          [text]="'Edit'"
          [type]="'primary'"
          (click)="buttonClick('edit')">
  </gen-button>
</section>
